import React, { PureComponent } from 'react';
import PT from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { map } from 'lodash';
import debug from 'debug';
import FiltersHeader from '../../components/FiltersHeader';
import TableControls from '../../components/TableControls';
import { selectControlsState } from '../../../store/reducers/tableControls';
import DataTable from '../../components/DataTable';
import FilterRangeSlider from '../../components/FilterComponents/FilterRangeSlider';
import ColGroupsTypes from '../../../lib/proptypes/colGroups';
import { goToView } from '../../routes.global';
import {
  TEAM_POSITION_RANKINGS_VIEW,
  selectTeamPositionRankingsState,
  changeSelectedYear,
  changeSelectedStartWeek,
  changeSelectedEndWeek,
  changeSelectedFormula,
  fetchTeamPositionRankings,
} from './module/teamPositionRankings';
import classes from './TeamPositionRankings.css';
import {
  selectToolDescriptionsState,
} from '../../../store/reducers/toolDescriptions';
import { ToolDescription } from '../../components/ToolDescriptions/ToolDescriptions';
import { gciPageView } from '../../../lib/analytics';

const log = debug('huddle:app:views:teamPositionRankings');
const pageTitle = 'Team Position Ranks';

const mapStateToProps = state => {
  const {
    rankings,
    selectedYear,
    selectedStartWeek,
    selectedEndWeek,
    selectedFormula,
    minWeek,
    maxWeek,
    hasLoaded,
    tableColGroups,
  } = selectTeamPositionRankingsState(state);
  const {
    toolDescriptions,
    toolsLoaded,
  } = selectToolDescriptionsState(state);
  return {
    hasLoaded,
    ...hasLoaded && {
      rankings,
      selectedYear,
      selectedStartWeek,
      selectedEndWeek,
      selectedFormula,
      minWeek,
      maxWeek,
      offensiveColGroups: tableColGroups.offensive,
      defensiveColGroups: tableColGroups.defensive,
      collapsed: selectControlsState(state).collapsed,
      toolDescriptions,
      toolsLoaded,
    },
  };
};
const actions = {
  goToView,
  changeSelectedYear,
  changeSelectedStartWeek,
  changeSelectedEndWeek,
  changeSelectedFormula,
  fetchTeamPositionRankings,
};
class TeamPositionRankings extends PureComponent {
  static propTypes = {
    rankings: PT.object,
    hasLoaded: PT.bool,
    selectedYear: PT.number,
    selectedStartWeek: PT.number,
    selectedEndWeek: PT.number,
    selectedFormula: PT.number,
    minWeek: PT.number,
    maxWeek: PT.number,
    offensiveColGroups: ColGroupsTypes,
    defensiveColGroups: ColGroupsTypes,
    goToView: PT.func.isRequired,
    changeSelectedYear: PT.func.isRequired,
    changeSelectedStartWeek: PT.func.isRequired,
    changeSelectedEndWeek: PT.func.isRequired,
    changeSelectedFormula: PT.func.isRequired,
    fetchTeamPositionRankings: PT.func.isRequired,
    toolsLoaded: PT.bool.isRequired,
    gciPageView: PT.func.isRequired,
  }

  static defaultProps = {
    rankings: null,
    selectedYear: null,
    selectedStartWeek: 1,
    selectedEndWeek: null,
    selectedFormula: null,
    minWeek: null,
    maxWeek: null,
    hasLoaded: false,
    offensiveColGroups: [],
    defensiveColGroups: [],
  }

  handleChangeYear = (event, { value }) => {
    if (this.props.selectedYear !== value) {
      this.props.goToView(TEAM_POSITION_RANKINGS_VIEW, { query: { season: value } });
    }
  }

  handleChangeFormula = (event, { value }) => {
    if (this.props.selectedFormula !== value) {
      this.props.goToView(TEAM_POSITION_RANKINGS_VIEW, { query: { formula_id: value } });
    }
  }

  handleChangeWeeks = ({ min, max }) => {
    if (this.props.selectedStartWeek !== min) {
      this.props.changeSelectedStartWeek(min);
    }
    if (this.props.selectedEndWeek !== max) {
      this.props.changeSelectedEndWeek(max);
    }
    this.props.fetchTeamPositionRankings(this.props.selectedYear, min, max);
  }

  renderDataTable = (data, colGroups) => {
    const ranks = map(data, (team) => ({ ...team, 'Team': team.team_abbr, }));
    return (
      <DataTable
        className={this.props.collapsed ? classes.collapsed : ''}
        data={ranks}
        colGroups={colGroups}
        initialSortColumn={'team_abbr'}
        sortAscending={true}
      />
    );
  }

  renderTeamPositionRankings = () => {
    const {
      selectedYear,
      selectedStartWeek,
      selectedEndWeek,
      selectedFormula,
      minWeek,
      maxWeek,
      rankings,
      offensiveColGroups,
      defensiveColGroups,
      hasLoaded,
      toolDescriptions,
      toolsLoaded,
    } = this.props;
    let offensiveData = [];
    let defensiveData = [];
    if (rankings) {
      ({ offensive: offensiveData, defensive: defensiveData } = rankings.team_ranks);
    }
    const maxValue = selectedYear >= 2021 ? 18 : 17;
    return (
      <div>
        <FiltersHeader
          title={pageTitle}
          description={toolsLoaded && toolDescriptions.tool_descriptions.team_position_rankings.visible == 1 && (
            <ToolDescription
              descr={toolDescriptions.tool_descriptions.team_position_rankings.text}
            />)}
          seasonType={'seasons'}
          statType="stats"
          selectedYear={selectedYear}
          selectedProfile={selectedFormula}
          onChangeProfile={this.handleChangeFormula}
          onChangeYear={this.handleChangeYear}
        >
          <FilterRangeSlider
            id="start-week-slider"
            sliderLabel="Show Range:"
            value={{ min: selectedStartWeek, max: selectedEndWeek }}
            minValue={1}
            maxValue={maxValue}
            onChangeComplete={this.handleChangeWeeks}
          />
        </FiltersHeader>
        <TableControls
            track
            compare
            injury
            colGroups={offensiveColGroups}
        />
        {hasLoaded && !!rankings ?
          <div className={classes.rankingsWrapper}>
            {this.renderDataTable(offensiveData, offensiveColGroups)}
            {this.renderDataTable(defensiveData, defensiveColGroups)}
          </div>
          : 'Loading Team Position Ranks...'
        }
      </div>
    );
  }

  render() {
    return (
      <div className={classes.wrapper}>
        {this.renderTeamPositionRankings()}
      </div>
    );
  }

  componentDidMount() {
    document.title = pageTitle + ' - TheHuddle';
    gciPageView(pageTitle);
  }
}
export default connect(mapStateToProps, actions)(TeamPositionRankings);



// WEBPACK FOOTER //
// ./src/app/views/TeamPositionRankings/TeamPositionRankings.js